<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Gifts</h1>
    </div>

    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <router-link :to="{ name: 'gift-page' }">Gift</router-link> /
      <b>Edit</b>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12 card mb-4">
        <div class="card-body">

          <h4 class="card-title mb-3">
            <b>Gift</b>
          </h4>

          <p>Fill in the information</p>

          <form @submit.prevent="handleSubmission">
            <div class="col-12 mb-4">
              <label><b>Gift Name</b></label>
              <input class="form-control" type="text" v-model="data.name" />
            </div>

            <div class="col-12 mb-4">
              <label><b>Price $ {{ rate }}</b></label>
              <input class="form-control" type="text" v-model="data.price" />
            </div>

            <div class="col-12 mb-4">
              <label><b>Quantity</b></label>
              <input class="form-control" type="text" v-model="data.quantity" />
            </div>

            <div class="row">
              <div class="col-3 mb-4">
                <img v-if="data.image" :src="data.image" class="img-fluid" width="300" /><br />
                <label><b>Upload</b></label> <small class="text-danger ml-4">* Recommended image upload size 250px x 250px</small><br />
                <input
                  type="file"
                  ref="file"
                  class="inputfile"
                  v-on:change="handleFileUpload"
                />
              </div>

              <div v-show="current_user_takaful" class="col-2 mb-4">
                <label><b>Expiry on Day</b></label><br />
                <div class="row">
                  <input type="number" class="form-control col-8 mr-2" v-model="data.expiry_days"/> Days
                </div>
              </div>
  
              <div class="col-4 mb-4">
                <label><b>Status</b></label>
                <div class="row">
                  <label class="radio radio-success ml-3">
                      <input type="radio" name="activeStatus" v-model="data.active" v-bind:value="a">
                      <span>Active</span>
                      <span class="checkmark"></span>
                  </label>
                  <label class="radio radio-danger ml-3">
                      <input type="radio" name="activeStatus" v-model="data.active"  v-bind:value="b">
                      <span>Inactive</span>
                      <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="float-left">
              <button
                type="submit"
                class="btn btn-primary btn-wide mt-4"
              >
                Update 
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { updateVendorGift, getGift, getRate } from "../../../services/GiftServices";
export default {
  data() {
    return {
      a: 1,
      b: 0,

      rate: null,

      data: {
        name: '',
        price: '',
        quantity: '',
        upload: '',
        image: '',
        active: 1,
        expiry: ''
      },

      imageUploaded: null,
      id: 1,
      current_user_takaful: false,
    }
  },

  methods: {
    handleFileUpload() {
      this.data.upload = this.$refs.file.files[0];
      this.data.image = URL.createObjectURL(this.data.upload);
      this.imageUploaded = this.data.upload;
    },

    async fetchData() {
      this.id = this.$route.params.id;

      try {
        const response = await getGift(this.id);

        if(response.data.success) {
          this.data = response.data.data;
        }

      } catch (e) {
        console.error(e);
      }
    },

    async fetchRate() {
      try {
        const response = await getRate();

        if(response.data.success) {
          let rate = response.data.data.earn_rate;

          this.rate = '(x' + rate + ' points)';
        }

      } catch (e) {
        console.error(e);
      }
    },

    async handleSubmission() {
      const formData = new FormData();
      if(this.data.upload) {
        formData.append('image', this.data.upload);
      }
      formData.append('name', this.data.name);
      formData.append('quantity', this.data.quantity);
      formData.append('active', this.data.active);
      formData.append('price', this.data.price);

      if(this.current_user_takaful) {
        formData.append('expiry', this.data.expiry_days);
      }
      
      try {
        const response = await updateVendorGift(formData, this.data.id);

        swal({
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });
      } catch (e) {
        console.error(e);
      }
    },

    checkCurrentUser() {
      const user = JSON.parse(localStorage.getItem('user'));
      this.current_user_takaful = user.username === 'vendor.takaful' ? true : false;
    }
  },

  async mounted() {
    await this.fetchData();
    this.checkCurrentUser();

    if(this.current_user_takaful) {
      await this.fetchRate();
    }
  },
}

</script>

<style scoped>
input[type="file"]::file-selector-button {
  margin-right: 20px;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  color: #fff;
  background-color: #AC8400;
  border-color: #AC8400;

  /* cursor: pointer; */
  transition: background 0.2s ease-in-out;
}

input[type="file"]::file-selector-button:hover {
  color: #fff;
    background-color: #806200;
    border-color: #b38900;
}
</style>
